import { AvailabilityTemplateDay } from "./availabilityTemplateDay";
import { AvailabilityTimeRange } from "./availabilityTimeRange";

export class AvailabilityTemplate {
    public availabilityTempateDay: AvailabilityTemplateDay[] = [];
}